import type { PublicacaoResponse, SituacaoPublicacao } from '@triade/contracts';
import { ROTULO_SITUACAO_PUBLICACAO } from '@triade/contracts';
import { cn } from '@/lib/utils';
import { formatarData } from '@/lib/format';

const ESTILO_SITUACAO: Record<SituacaoPublicacao, string> = {
  PROGRAMADA: 'bg-primary/10 text-primary',
  VIGENTE: 'bg-success-bg text-success-ink',
  ENCERRADA: 'bg-secondary text-ink-muted',
};

/** Selo da situacao (Programada azul, Vigente verde, Encerrada cinza). A situacao vem pronta da API. */
export function SeloSituacao({ situacao, className }: { situacao: SituacaoPublicacao; className?: string }) {
  return (
    <span data-situacao={situacao} className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-caption font-medium whitespace-nowrap', ESTILO_SITUACAO[situacao], className)}>
      {ROTULO_SITUACAO_PUBLICACAO[situacao]}
    </span>
  );
}

/** "20/12/2026 a 31/12/2026", ou "a partir de 01/10/2026 · sem fim" quando nao ha ultimo dia. */
export function vigenciaTexto(p: Pick<PublicacaoResponse, 'validFrom' | 'validAte'>): string {
  return p.validAte ? `${formatarData(p.validFrom)} a ${formatarData(p.validAte)}` : `a partir de ${formatarData(p.validFrom)} · sem fim`;
}

/** Mensagem de estado (vazio, carregando) no mesmo visual da tela. */
export function MensagemPublicacoes({ children, papel }: { children: React.ReactNode; papel?: 'status' }) {
  return (
    <p role={papel} className="px-5 py-8 text-center text-small text-ink-muted">
      {children}
    </p>
  );
}
